import { Container, Row, Button, Col } from "react-bootstrap";
import {
  addViewAtom,
  moveTabAtom,
} from "datasheets/model/atoms/WorkbookActionAtoms";
import { useAtom, useSetAtom } from "jotai";
import { EditableViewName } from "./EditableViewName";
import { useDrag, useDrop } from "react-dnd";
import { Divider, ListItemText, Menu, MenuItem } from "@mui/material";
import { Fragment, useState } from "react";
import { DnDItemTypes } from "../../../utils/DragAndDrop";
import { ViewFactory } from "datasheets/model/ViewFactory";
import { viewOrderAtom } from "datasheets/model/atoms/WorkbookFocusAtoms";

function correctIndicesAndMoveTab(
  fromIndex: number,
  toIndex: number,
  moveTab: (update: { from: number; to: number }) => void
) {
  if (fromIndex === toIndex || fromIndex === toIndex - 1) {
    console.log("Drag and drop tab", fromIndex, "to itself");
    return;
  }
  const destIndex = fromIndex < toIndex ? toIndex - 1 : toIndex;
  console.log("Dropping tab", fromIndex, "to", destIndex);
  moveTab({ from: fromIndex, to: destIndex });
}

function TabReorderTarget({ targetIndex }: { targetIndex: number }) {
  const [tabs] = useAtom(viewOrderAtom);
  const moveTab = useSetAtom(moveTabAtom);
  const [{ isDropTarget: isCurrentDropTarget, srcIndex }, drop] = useDrop(
    () => ({
      accept: DnDItemTypes.TAB,
      drop: (item: { index: number }) =>
        correctIndicesAndMoveTab(item.index, targetIndex, moveTab),
      collect: (monitor: any) => ({
        isDropTarget: !!monitor.isOver(),
        srcIndex: monitor.getItem()?.index ?? 0,
      }),
    }),
    [targetIndex]
  );
  const srcViewId = tabs[srcIndex];
  const dropTarget = isCurrentDropTarget ? (
    <EditableViewName
      key={"drop" + targetIndex}
      viewId={srcViewId}
      index={-1}
      isDragging={false}
      isDropTarget={true}
    />
  ) : (
    <>
      <Divider orientation="vertical" sx={{ width: "2px" }} />
    </>
  );
  return <span ref={drop}>{dropTarget}</span>;
}

function DraggableTab({ index, viewId }: { index: number; viewId: string }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: DnDItemTypes.TAB,
    item: { index },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));
  return (
    <div ref={drag}>
      <EditableViewName
        key={viewId}
        viewId={viewId}
        index={index}
        isDragging={isDragging}
      />
    </div>
  );
}

function Footer() {
  const [workbookTabs] = useAtom(viewOrderAtom);
  const [showNewViewSelector, setShowNewViewSelector] = useState(false);
  const addView = useSetAtom(addViewAtom);
  const tabs = workbookTabs.map((viewId, index) => (
    <Fragment key={viewId + index.toString()}>
      <DraggableTab index={index} viewId={viewId} />
      <TabReorderTarget targetIndex={index + 1} />
    </Fragment>
  ));
  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const addViewHandler = () => {
    const e = window.event as MouseEvent;
    if (e.shiftKey) {
      handleMenuOpen(e);
      setShowNewViewSelector(true);
    } else {
      addView();
    }
  };
  const viewSelectorTypes = ViewFactory.availableTypes().map((type) => {
    return (
      <MenuItem
        key={type}
        onClick={() => {
          addView(type);
          setShowNewViewSelector(false);
        }}
      >
        <ListItemText>{type}</ListItemText>
      </MenuItem>
    );
  });
  return (
    <Container className="Panel Footer" fluid>
      <Row>
        <Col sm={1}>
          <Button onClick={addViewHandler} role="add-sheet-button">
            +
          </Button>
          <Menu
            open={showNewViewSelector}
            onClose={() => {
              handleMenuClose();
              setShowNewViewSelector(false);
            }}
            anchorEl={anchorEl}
          >
            {viewSelectorTypes}
          </Menu>
        </Col>
        <Col style={{ display: "flex", justifyContent: "left" }}>
          <TabReorderTarget key="index0" targetIndex={0} />
          {tabs}
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
